import { useEffect, useState } from "react";
import { useGlobalStore } from "@/store/GlobalStore";
import { useFoxTopUpStore } from "@/pages/fox-top-up/store";

export function useMemberSystem() {
  const [currenProgress, setCurrentProgress] = useState(0);
  const [progressbar, setProgressbar] = useState<number>(0);
  const [nextLevel, setNextLevel] = useState<number>(0);
  const { userInfo } = useGlobalStore();
  const [percent, setPercent] = useState(0);
  const HangTags = useFoxTopUpStore((state) => state.HangTags);

  useEffect(() => {
    if (!HangTags.length || !userInfo) return;
    setCurrentProgress(userInfo.usdCumulative || 0);

    const nextLevel = HangTags.find((i) => i.level > (userInfo.level || -1));
    setProgressbar(
      nextLevel ? nextLevel.usdCumulative : userInfo.usdCumulative || 0
    );
    setNextLevel(
      nextLevel && !userInfo.tempMemberValidityTime ? nextLevel.level : -1
    );
  }, [HangTags, userInfo]);

  useEffect(() => {
    let percent = (currenProgress / Number(progressbar)) * 100;

    if (percent < 0) {
      percent = 0;
    }
    if (percent > 100) {
      percent = 100;
    }
    setPercent(percent);
  }, [currenProgress, progressbar]);

  return { currenProgress, progressbar, percent, nextLevel };
}
